import { FC, SyntheticEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import EventsTable from './EventsTable'
import EventEditModal from './EventEditModal'

const EventsList: FC = () => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-2 mb-4'>
        <button
          className='btn btn-sm btn-light'
          onClick={() => {
            navigate('/events/list')
          }}
        >
          <span className='fa fa-list me-2'></span>
          List View
        </button>
        <button
          className='btn btn-sm btn-light'
          onClick={() => {
            navigate('/events/calendar')
          }}
        >
          <span className='fa fa-calendar me-2'></span>
          Calendar View
        </button>
      </div>
      <EventsTable
        onEdit={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        onDelete={(id: any, refresh: Function) => {
          axios.get('/events/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this event?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('events/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        onAdd={(_event: SyntheticEvent, refresh: Function) => {
          setItemIdForUpdate('add')
          setRefreshFunction(() => refresh)
        }}
      />
      {itemIdForUpdate !== '' ? (
        <EventEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}
export default EventsList
